module.exports = __webpack_public_path__ + "img/customer_service.a14cbfd0.png";